<template>
  <div class="pricing_plan" :class="{ highlight: plan.popular }">
    <h4>{{ plan.name }}</h4>
    <div class="pricing_plan_price">
      <span>{{ plan.price }}</span
      >/{{ period }}
    </div>
    <div class="btn-container">
      <button type="button" class="btn-st pay-button">
        {{ $t("PRC_ACT") }}
      </button>
      <button type="button" class="btn-st pay-button" @click="setPlan">
        Set Plan
      </button>
    </div>
    <ul class="feat_list">
      <li>
        {{ $t("PRC_USR") }} <span>{{ plan.accessCount }}</span>
      </li>
      <li>
        {{ $t("PRC_SMP") }} <span>{{ plan.pageCount }}</span>
      </li>
      <li>
        {{ $t("PRC_DEPTH") }} <span>{{ plan.retrospective }}</span>
      </li>
      <li>
        {{ $t("PRC_SPP") }} <span>{{ plan.api }}</span>
      </li>
    </ul>
    <ul class="feat_list">
      <li>{{ $t("PRC_CMPR") }}</li>
      <li>{{ $t("PRC_STR") }}</li>
      <li>{{ $t("PRC_INN") }}</li>
      <li>{{ $t("PRC_EXPORT") }} PDF, XLSX, PPTX</li>
      <li v-if="plan.autoReports === '--'" class="inactive">
        {{ $t("PRC_AREML") }}
      </li>
      <li v-if="plan.autoReports !== '--'">{{ $t("PRC_AREML") }}</li>
      <li v-if="plan.api === '--'" class="inactive">{{ $t("PRC_API") }}</li>
      <li v-if="plan.api !== '--'">{{ $t("PRC_API") }}</li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import module from '@/models/AxiosModule'

export default {
  props: {
    plan: Object,
    period: String
  },
  computed: {
    ...mapGetters([
      "getProfile",
    ]),
  },  
  methods: {
    async setPlan() {
      try {
        const axios = module.Axios;
        const response = await axios.post("create-plan", {
          email: this.getProfile.email,
          plan: {plan: this.plan.name, page_limit: this.plan.pageCount, days: 30}
        });
        console.log("Plan set successfully:", response.data);
      } catch (error) {
        console.error("Error setting plan:", error);
      }
    }
  }  
};
</script>

<style scoped>
/* Add styles if needed */
</style>